import styled, { css } from 'styled-components'
import { LinkButton } from '@sketch/components'
import { breakpoint } from '@sketch/global-styles'

export const CloseIconContainer = styled.div`
  position: absolute;
  right: 16px;
  top: 16px;
`

export const NewFeatureHighlightContainerSidebar = styled.div`
  position: absolute;
  right: -8px;
  bottom: -16px;
  left: initial;
  top: initial;

  ${breakpoint('sm')`${css`
    left: -8px;
    top: -8px;
  `}`}
`

export const NewFeatureHighlightContainerHeader = styled.div`
  position: absolute;
  right: -8px;
  bottom: -16px;
  left: initial;
  top: initial;

  ${breakpoint('sm')`${css`
    left: -8px;
    top: -8px;
  `}`}
`

export const StyledLinkButton = styled(LinkButton)`
  ${({ theme, variant }) =>
    variant === 'secondary' &&
    css`
      color: ${theme.colors.sketch.A};
    `}
`
